import { useEffect, useState } from "react";
import { serviceGetList } from "../../../../services/index.services";

function useDoctorTopFieldHook({ form }) {
  const [listData, setListData] = useState({
    CLIENTS: [],
    PROGRAMS: [],
    PROGRAM_DOCTORS: [],
  });

  useEffect(() => {
    const fetchStaticDropdowns = async () => {
      const res = await serviceGetList(["CLIENTS"]);
      if (!res?.error) {
        setListData((prev) => ({
          ...prev,
          CLIENTS: res?.data?.CLIENTS || [],
        }));
      }
    };

    fetchStaticDropdowns();
  }, []);

  console.log("Form",form)
  useEffect(() => {
    const clientId = form?.client_id;
    if (!clientId) {
      setListData((prev) => ({ ...prev, PROGRAMS: [] }));
      return;
    }

    const fetchPrograms = async () => {
      const res = await serviceGetList(["PROGRAMS"], { client_id: clientId });
      if (!res?.error) {
        setListData((prev) => ({
          ...prev,
          PROGRAMS: res?.data?.PROGRAMS || [],
        }));
      }
    };

    fetchPrograms();
  }, [form?.client_id]);

  useEffect(() => {
    const programIDs = form?.program_ids
      ? form?.program_ids?.map((val) => val?.id)
      : [];
    if (!programIDs) {
      setListData((prev) => ({ ...prev, PROGRAM_DOCTORS: [] }));
      return;
    }

    const fetchDoctorList = async () => {
      const res = await serviceGetList(["PROGRAM_DOCTORS"], {
        program_ids: programIDs,
      });
      if (!res?.error) {
        const data = res?.data?.PROGRAM_DOCTORS || [];
        setListData((prev) => ({
          ...prev,
          PROGRAM_DOCTORS: [
            { id: "ALL_DOCTORS", name: "All Doctors" },
            ...data,
          ],
        }));
      }
    };

    fetchDoctorList();
  }, [form?.program_ids]);

  return {
    listData,
  };
}

export default useDoctorTopFieldHook;
